export default __webpack_public_path__ + "static/media/down-green.1708d468.svg";